// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.dr.ts`.
// The list of file replacements can be found in `angular.json`.

// Spring Boot Gateway (AWS ALB)
const api_base_url = '/dr/consumer-onboarding';

export const environment = {
  production: true,
  development: false,
  env: 'dr',
  dns: 'https://consumeradmin.texascapitalbank.com',
  local: false,
  api_base_url: api_base_url,
  api_base_url_mando: api_base_url + '/mando',
  api_base_url_falcon: api_base_url + '/falcon',
  api_base_url_leia: api_base_url + '/leia',
  api_base_url_skyhopper: api_base_url + '/skyhopper',
  client_base_url_bb8: "https://join.texascapitalbank.com/",
  app_settings_version: 1,
  okta_client_id: "0oav2ydsma8GEW3ET0x7",
  okta_issuer: 'https://tcb.okta.com/oauth2/default',
  okta_signout_path: 'https://gateway.texascapitalbank.net/',
  appBaseHref: '/',
  socureSdkKey: "4bf53ae9-8c34-476f-bef1-b7b4482bb736",
  socureProcessFlow: 1,
  googleMapsId: "AIzaSyDzhvedYvawqOyUaeXBmtOCOoVtVpJEto8",
  features: {
    AlloyUpdate: false,
    PushToAlloy: true,
    AuditLog: false,
    Nao: false,
    ApplicantPushMenu: true,
    PushToOlb: false,
    Campaign: true
  },
  dataDogClientToken: "pub805e03aa0a4dbd1e020db22fec102af2",
  dataDogApplicationId: "eb424494-9131-4daf-ad5c-c1a510423120",
  dataDogService: "consumeronboarding-coruscant-dr",
  client_bask_base_url_bb8: "https://join.baskbank.com/",
};
